// extracted by mini-css-extract-plugin
export default {"page":"PrintTestTakerTickets_page__c2ACC","body":"PrintTestTakerTickets_body__PODsf"};